import Close from '@mui/icons-material/Close';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import { UnitDetails } from './UnitDetails';

const PartProductsViewerModal = props => {
  const {
    show,
    closeHandler,
    partDisplay,
    arrangedRows = [],
    loading = false,
    onSelectCell,
  } = props;

  return (
    <Dialog
      open={show}
      onClose={closeHandler}
      fullWidth
      maxWidth="md"
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        محتویات آدرس
        <IconButton onClick={closeHandler} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack gap={1.5}>
          {partDisplay ? (
            <Typography variant="body2" color="text.secondary">
              بخش: {partDisplay}
            </Typography>
          ) : null}

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              {arrangedRows.length ? (
                arrangedRows.map(unit => (
                  <UnitDetails
                    key={unit.guid}
                    unit={unit}
                    onSelectCell={onSelectCell}
                  />
                ))
              ) : (
                <Box sx={{ px: 1.5, py: 3, textAlign: 'center' }}>
                  <Typography variant="body2" color="text.secondary">
                    آدرسی یافت نشد
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PartProductsViewerModal;
